import React from 'react';
import { Section } from './ui/Section';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <Section className="bg-brand-dark text-white border-y border-brand-light" data-id="element-92">
      <div className="max-w-3xl mx-auto text-center" data-id="element-93">
        <div className="flex justify-center mb-4 md:mb-8" data-id="element-94">
          <div className="w-16 h-16 md:w-24 md:h-24 bg-brand-accent/20 rounded-full flex items-center justify-center border-2 border-brand-accent/50" data-id="element-95">
            <ShieldCheck className="w-8 h-8 md:w-12 md:h-12 text-brand-accent" data-id="element-96" />
          </div>
        </div>

        <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 md:mb-6 text-brand-accent" data-id="element-97">
          ✨ GARANTÍA PATINAJE ARTÍSTICO RESUELTO — 7 DÍAS ✨
        </h2>

        <div className="space-y-2 md:space-y-4 text-sm md:text-xl text-white font-light mb-5 md:mb-8" data-id="element-98">
          <p data-id="element-99">Abrís los 6 tomos. Revisás los 6 bonos.</p>
          <p data-id="element-100">Los usás en tu clase si querés.</p>
          <p className="font-bold text-brand-accent text-base md:text-2xl" data-id="element-101">
            Si en 7 días no es lo que esperabas:
            <br data-id="element-102" />
            Te devolvemos el 100%.
          </p>
          <p data-id="element-103">Sin preguntas. Sin formularios. Sin drama.</p>
        </div>

        <p className="text-xs md:text-base text-brand-ice/80 italic mb-5 md:mb-8" data-id="element-104">
          La confianza que tenemos en Patinaje Artístico Resuelto™ nos permite
          hacer esa promesa sin dudar.
        </p>

        <div className="inline-block bg-brand-light border border-brand-dark/30 px-4 md:px-6 py-2 md:py-3 rounded-full text-xs md:text-sm font-bold tracking-widest uppercase text-brand-ice/80" data-id="element-105">
          TASA DE DEVOLUCIONES MENOR AL 1%
        </div>
      </div>
    </Section>;
}